import React from "react";
import { CsplTable as Table } from "../../../components";
import { get } from "lodash";
import {
  getAdvancedPathWithParam,
  MANAGE_CENSUS_ROUTES,
  FLOW_TYPES,
} from "../../../utils";
import { Link } from "react-router-dom";

function BeneficiaryTableComponent(props) {
  const {
    data,
    title,
    setPercentageOpen,
    censusId,
    setSelectedBeneficiaryDetails,
    history,
  } = props;
  return (
    <div style={{ marginTop: "30px" }}>
      <Table>
        <Table.Thead>
          <Table.Tr>
            {[
              {
                label: (
                  <div style={{ fontSize: "16px" }}>
                    {title} - {data.length}{" "}
                  </div>
                ),
              },
              {
                label: (
                  <div
                    onClick={() => {
                      setPercentageOpen(true);
                      setSelectedBeneficiaryDetails(data);
                    }}
                    style={{
                      color: "blue",
                      marginLeft: "auto",
                      cursor: "pointer",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    {data
                      .map((x) => x.percentage)
                      .reduce((x, a) => x + a, 0) === 0
                      ? "Set Percentage"
                      : "Edit Percentage"}
                  </div>
                ),
              },
            ].map((item, index) => {
              return <Table.Th key={index}>{item.label}</Table.Th>;
            })}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.map((bene, index) => {
            return (
              <Table.Tr style={{ padding: "25px 0px" }} key={index}>
                <Table.Td className="w-90">
                  <div>
                    <Link
                      onClick={() =>
                        history.push(
                          getAdvancedPathWithParam({
                            path: MANAGE_CENSUS_ROUTES.ADD_BENEFICIARY,
                            pathParam: [FLOW_TYPES.EDIT, censusId, bene.id],
                          })
                        )
                      }
                    >
                      {get(bene, "name", "")}
                    </Link>
                    <div>
                      Relationship :{" "}
                      <span style={{ fontWeight: "500" }}>
                        {" "}
                        {get(bene, "relationship", "")}
                      </span>
                    </div>
                  </div>
                </Table.Td>
                <Table.Td className="w-10">
                  {get(bene, "percentage", "0%")}%
                </Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
      <div
        style={{
          width: "94%",
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "600",
          fontSize: "16px",
          marginTop: "30px",
        }}
      >
        <div>Total {title} Percentage</div>
        <div className="ms-auto">
          {data && data.map((x) => x.percentage).reduce((x, a) => x + a, 0)}%
        </div>
      </div>
    </div>
  );
}

export default BeneficiaryTableComponent;
